import * as yup from 'yup';
import {
  SuggestionSchema,
  ScaleRatingSuggestionSchema,
  MealComponentSchema,
} from '../../../common';

export const CarePlan3SuggestionSchema = yup.object({
  prepareBiteSize: ScaleRatingSuggestionSchema.nullable(),
  eat: ScaleRatingSuggestionSchema.nullable(),
  drink: ScaleRatingSuggestionSchema.nullable(),
  aids: SuggestionSchema.nullable(),
  tube: SuggestionSchema.nullable(),
  application: SuggestionSchema.nullable(),
  dietType: SuggestionSchema.nullable(),
  activityFactor: SuggestionSchema.nullable(),
  mealType: SuggestionSchema.nullable(),
  mealComponents: yup.array().of(MealComponentSchema).default([]),
  oralCare: SuggestionSchema.nullable(),
  aspirationProphylaxis: SuggestionSchema.nullable(),
  other: SuggestionSchema.nullable(),
});

export type ICarePlan3Suggestion = yup.InferType<typeof CarePlan3SuggestionSchema>;
